type Props = {
  brandDescription: string | null
  productDescription: string | null
  isPreOwned: boolean
}

export function getDescription({ brandDescription, productDescription, isPreOwned }: Props) {
  if (isPreOwned && productDescription && brandDescription) {
    return `${productDescription} <br/> <br/>${brandDescription}`
  }

  if (productDescription) {
    return productDescription
  }

  return brandDescription
}
